import { withDictionaryInitialization } from '@/pages/dictionary/hocs';

export default withDictionaryInitialization;
